import { DataBean } from "../DataBean";

export class ProjectSchedule extends DataBean {
    
    
    public async getProjectScheduleCatalogPorPropiedades(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("FinanceCore", "java.util.List_getProjectScheduleCatalogPorPropiedades_java.util.Map_Number", [properties,maxRows]);
    }

    public async getProjectBeneficiaryCatalogPorPropiedadesRender(props:any,rows:any): Promise<any> {
        return this.getCustomService("FinanceCore", "java.util.List_getProjectBeneficiaryCatalogPorPropiedadesRender_java.util.Map_Number", [props,rows]);
    }
    public async getProjectScheduleRender( page:number, rows:number,props:any): Promise<any> {
        return this.getCustomService("FinanceCore", "com.advantage.shared.Report_getProjectScheduleRender_Number_Number_java.util.Map", 
            [page,rows,props]);
    }
    public async getProjectScheduleHistoryRender( page:number, rows:number,props:any): Promise<any> {
        return this.getCustomService("FinanceCore", "com.advantage.shared.Report_getProjectScheduleHistoryRender_Number_Number_java.util.Map", 
            [page,rows,props]);
    }
    public async responseTask( idProjectSchedule:number, idEmployee:number,stateTask:number,props:any): Promise<any> {
        return this.getCustomService("FinanceCore", "com.advantage.shared.Report_responseTask_Number_Number_Number_java.util.Map", 
            [idProjectSchedule,idEmployee,stateTask,props]);
    }

  

}